import React from "react";

const AddOutlet = () => {
  return (
    <div>
      <div>Add Outlet</div>
    </div>
  );
};

export default AddOutlet;
